import { render, staticRenderFns } from "./viewTraslado.vue?vue&type=template&id=75aa156c&"
import script from "./viewTraslado.vue?vue&type=script&lang=js&"
export * from "./viewTraslado.vue?vue&type=script&lang=js&"
import style0 from "./viewTraslado.vue?vue&type=style&index=0&id=75aa156c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports